import { render, staticRenderFns } from "./yjsftj.vue?vue&type=template&id=46561638"
import script from "./yjsftj.vue?vue&type=script&lang=js"
export * from "./yjsftj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports